<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip
          class="item"
          effect="dark"
          content="返回上一级页面"
          placement="bottom-start"
          :disabled="showTooltip"
        >
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3>
          <span v-show="!create">修改预警信息</span>
          <span v-show="create">新增预警信息</span>
        </h3>
      </el-col>
    </el-row>
    <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
    <div style="max-width: 800px">
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="180px"
        v-loading="showLoading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="票据种类" prop="einvoiceTypeCode" ref="ipt00">
              <el-select v-model="form.einvoiceTypeCode" placeholder="请选择票据种类" :disabled="!create">
                <el-option
                  v-for="item in einvoiceTypeCodeOptions"
                  :key="item.einvoiceTypeCode"
                  :label="item.einvoiceTypeName"
                  :value="item.einvoiceTypeCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存阀值" prop="thresholds">
              <el-input
                ref="ipt01"
                v-model="form.thresholds"
                placeholder="请输入库存阀值"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="监控频率" prop="frequency">
              <el-input
                ref="ipt02"
                v-model="form.frequency"
                placeholder="请输入监控频率"
                maxlength="10"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="recordDataUserClass">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">添加接收人信息</el-button>
            <el-table ref="table" :data="recordDataUser" highlight-current-row border style="width: 100%" :header-cell-style="{background:'#F5F7FA',color:'#606266'}">
                <!-- <el-table-column prop="notifyType" label="接收方式" width="120"></el-table-column> -->
                <!-- <el-table-column label="接收方式">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.notifyType" controls-position="right" placeholder="请输入" maxlength="30" ></el-input>
                    </template>
                </el-table-column> -->

                <el-table-column label="接收方式">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.notifyType" placeholder="请选择">
                            <el-option v-for="item in notifyTypeOptions" :key="item.value" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="接收人">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.userId" controls-position="right" placeholder="请输入" maxlength="20" ></el-input>
                    </template>
                </el-table-column> -->
                <el-table-column label="接收人">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.userName" controls-position="right" placeholder="请输入" maxlength="20" 
                            @focus="showDiyTree(scope.row.userId,scope.$index)"
                        ></el-input>
                    </template>
                </el-table-column> 
                <el-table-column label="通知地址">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.notifyAddress" controls-position="right" placeholder="请输入" maxlength="100"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="onRemove(scope.row,scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-form-item>
            <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <tree ref="myTree" @treeCallBack="treeCallBack($event)"></tree>
  </div>
</template>

<script>
import _ from "lodash";
import tree from "./Tree"

let _kits, _form, fn;
export default {
  components: {
      tree
  },
  props: ["entity"],
  data() {
    var checkThresholds = (rule, value, callback) => {
        const reg =  /^\+?[1-9]\d*$/;
        if (!reg.test(value)) {
            callback(new Error("库存阀值只能是数字"));
        } else {
            callback();
        }
    };
    var checkFrequency = (rule, value, callback) => {
        const reg =  /^\+?[1-9]\d*$/;
        if (!reg.test(value)) {
            callback(new Error("监控频率只能是数字"));
        } else {
            callback();
        }
    };
    let create = !this.entity.warnCode;
    let form = {
      agencyCode: this.entity.agencyCode,
      organId: this.entity.organId,
      warnCode: this.entity.warnCode
    };
    let data = {
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      recordDataUser: [], //展示信息
      einvoiceTypeCodeOptions: [],
      create,
      form,
      notifyTypeOptions: [],
      treeData: [],
      formRules: {
          einvoiceTypeCode: [{
                required: true,
                message: "请输入票据种类",
                trigger: "blur"
            }
          ],
          thresholds: [{
                required: true,
                message: "请输入库存阀值",
                trigger: "blur"
            }, {
                validator: checkThresholds,
                trigger: "blur"
            }
          ],
          frequency: [{
                required: true,
                message: "请输入监控频率",
                trigger: "blur"
            }, {
                validator: checkFrequency,
                trigger: "blur"
            }
          ]
      }
    };
    console.log("data is ", data);
    return data;
  },
  methods: {
    showDiyTree(id,index) {
      
      console.log("index",index)
      var option = {title:'操作人员', placeholder: '请输入操作人员名称', treeCallBack: (nodes) => {
                          console.log("nodes.length",nodes.length)
                                  if (nodes.length == 0) {
                                     this.recordDataUser[index].userId = ''
                                  } else {                                    
                                        this.recordDataUser[index].userName = nodes[0].label;
                                        this.recordDataUser[index].userId = nodes[0].id;
                                  }
                              }}
        fn = option.treeCallBack
        console.log("option.treeCallBack");
        this.$refs.myTree.showTree(this.treeData, id, option)
    },

    treeCallBack(nodes) {
      //console.log("nodes is ", nodes[0].label);
      console.log("fn is ", JSON.parse(JSON.stringify(nodes)));

        if (fn != undefined) {
            fn(nodes)
        }
    },
    initTreeData(fn_call, fn_filter) {
        _kits.api.call(
            "CZRYTREE",
            {
                jgDm: this.form.organId
            },
            result => {
                if (result.returnCode == "0000") {
                    fn_call(_kits.arr2TreeData(result.data, fn_filter))
                } else {
                    this.$message.error(result.returnMsg)
                }
            }
        )
    },
    onAdd() {
      const row = {
        notifyType: '',
        userId: '',
        userName: '',
        notifyAddress: ''
      }
      this.hh++;
      this.recordDataUser.unshift(row)
    },
    onRemove(row,index) {
      console.log("index",index)
      this.recordDataUser.splice(index, 1);
    },
    onBack() {
      this.$emit("back");
    },
    onSave() {
      let checked = true;
      let message = "";  
      this.recordDataUser.forEach(function(item, index) {
            if (item.notifyType == "") {
                checked = false;
                message = "接收方式不能为空";
                return false;
            }else{
                if(item.notifyType == "02"){
                    if (item.notifyAddress == "") {
                        checked = false;
                        message = "接收方式为短信时，通知地址不能为空";
                        return false;
                    }else{
                        const reg = /^1[3456789]\d{9}$/;
                        if (!reg.test(item.notifyAddress)) {
                            checked = false;
                            message = "接收方式为短信时，通知地址格式不正确";
                            return false;
                        }
                    }
                }
                if(item.notifyType == "03"){
                    if (item.notifyAddress == "") {
                        checked = false;
                        message = "接收方式为邮件时，通知地址不能为空";
                        return false;
                    }else{
                        const reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
                        if (!reg.test(item.notifyAddress)) {
                            checked = false;
                            message = "接收方式为邮件时，通知地址格式不正确";
                            return false;
                        }
                    }
                }
            }
            if (item.userId == "") {
                checked = false;
                message = "接收人不能为空";
                return false;
            }
        });
      if (checked) {
        this.form.recordDataUser = this.recordDataUser;
        console.log("_form", _form); 
        _form.submit();
      } else {
        this.$message.error(message);
      }
    },
    queryEinvoiceTypeCodeOption() {
      //this.einvoiceTypeCodeOptions = [];
      if (this.form.agencyCode == "") {
        this.einvoiceTypeCodeOptions = [];
        return;
      }
      _kits.api.call(
        "QUERYAGENCYEINVOICETYPECODE",
        {
          agencyCode: this.form.agencyCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.einvoiceTypeCodeOptions = result.data;
            if (this.form.einvoiceTypeCode == "" && result.data.length > 0) {
              this.form.einvoiceTypeCode = result.data[0].einvoiceTypeCode;
            }
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    }
  },
  created() {
    _kits = this.$kits();
    this.queryEinvoiceTypeCodeOption();
    if (!this.create) {
      _kits.api.call(
        "QUERYWARNMAINDETAILS",
        {
          warnCode: this.entity.warnCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.form = JSON.parse(JSON.stringify(result.data));
            this.recordDataUser = result.data.warnUserList;
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    }
    this.initTreeData(data => {
      console.log("initTreeData");
        this.treeData = data
    }, a => {
        //a.disabled =    a.type =='1'     // 添加属性
        //return false
    });
    _kits.api.call( 
        "GETCOLLECTION", {
            "collectionId": "warnUserNotifyTypeEnumCollection"
        },
        result => {
            if (result.returnCode == "0000") {
                this.notifyTypeOptions = result.data;
            } else {
                this.$message.error(result.returnMsg);
            }
        }
    );

  },
  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: this.create ? "ADDWARNMAINDETAILS" : "UPDATEWARNMAINDETAILS"
    });
    //*
    setTimeout(() => {
      _kits.page.foucus("ipt00");
      this.showLoading = false;
      this.showTooltip = true;
    }, 300);
  }
};
</script>

<style scoped>
    .recordDataUserClass {
        width: 100%;
        margin-top: 10px;
        margin-left: 100px;
    }

</style>
